import React, {Component} from "react";
import PageHeaderLayout from '../../layout/PageHeaderLayout'
import StandardTable from "../../components/StandardTable";
import {Card, Button, Divider, Modal, Upload, Icon, Popconfirm, Input} from "antd";
import authWrapper from "../../utils/authWrapper";
import * as api from "../../api/custom_picture";
import * as qiniu from "../../utils/qiniu";
import * as utils from "../../utils/utils";


const UploadButton = authWrapper('upload')(Button)
const DeletePopconfirm = authWrapper('delete')(Popconfirm)


class CustomPicture extends Component {

    state = {
        uploadModalVisible: false,
        uploading: false,
        files: [],
        searchKeyword: null
    }

    columns = [
        {
            title: '图片编号',
            dataIndex: 'picture_no'
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                <a onClick={() => window.open(record.path)}>查看</a>
                <Divider type='vertical'/>
                <DeletePopconfirm title={'是否确认删除'}
                                  onConfirm={() => this.onDelete(record.picture_no)}>
                    <a>删除</a>
                </DeletePopconfirm>
            </span>
            )
        }
    ]

    dataTable = null

    onUploadModalOk = () => {
        const files = this.state.files.map(item => {
            const [pictureNo] = utils.splitFileName(item.name)
            return {
                file: item,
                key: `custom_picture/${utils.extendFileName(item.name)}`,
                putExtra: {
                    params: {'x:pictureNo': pictureNo}
                }
            }
        })
        this.setState({uploading: true})
        qiniu.upload(files, 'custom_picture').then(() => {
            this.setState({uploading: false, uploadModalVisible: false})
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({uploading: false})
        })
    }

    onDelete = (pictureNo) => {
        api.deletePicture(pictureNo).then(() => {
            this.dataTable.fetch()
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'自定义图纸'} content={(
                <div style={{textAlign: 'center'}}>
                    <Input.Search style={{width: 500}}
                                  enterButton="搜索"
                                  onSearch={(value) => this.setState({searchKeyword: value})}
                    />
                </div>
            )}>
                <Card>
                    <div style={{marginBottom: 10}}>
                        <UploadButton onClick={() => this.setState({uploadModalVisible: true})}
                                      type={'primary'}>上传</UploadButton>
                    </div>
                    <StandardTable url={'/api/custom/picture/'}
                                   rowKey={'product_no'}
                                   columns={this.columns}
                                   ref={ref => this.dataTable = ref}
                                   keyword={this.state.searchKeyword}
                    />
                </Card>
                <Modal visible={this.state.uploadModalVisible}
                       onOk={this.onUploadModalOk}
                       onCancel={() => this.setState({uploadModalVisible: false})}
                       afterClose={() => this.setState({files: []})}
                       confirmLoading={this.state.uploading}
                       destroyOnClose
                >
                    <Upload accept='image/*,.pdf'
                            multiple
                            beforeUpload={(file) => {
                                this.setState((state) => ({files: [...state.files, file]}))
                                return false
                            }}
                            onRemove={(file) => {
                                const files = this.state.files
                                files.splice(files.indexOf(file), 1)
                                this.setState({
                                    files: files
                                })
                            }}
                    >
                        <Button>
                            <Icon type="upload"/>选择图片
                        </Button>
                    </Upload>
                </Modal>
            </PageHeaderLayout>
        );
    }
}

export default CustomPicture;
